<button
  (click)="clickAction()"
  [ngClass]="{'btn btn-info _mb-sm-2 mr-2 UNFAPP-lvmtrcls-jnbtn': true, 'UNFAPP-lvmtrcls-jnbtn': cta.type == 'register', 'UNFAPP-lvmtrcls-jnbtn rewatch': cta.type == 'rewatch', 'enroll-btn': cta.type == 'enroll', 'm-font-14': (cta.type == 'enroll' || cta.type == 'viewCourse'), 'LCS_rescheduled': cta.type == 'rescheduled'}"
  type="button"
  [disabled]="isButtonDisabled || isJoinButtonDisabled">
  {{cta.name}}

  <img
    *ngIf="['rewatch', 'teacherRewatch'].includes(cta.type)"
    class="LCS_rewatch-img"
    src="assets/img/rewatch-icon.svg"
    alt=""
  />
</button>